@charset "UTF-8";
:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

/*Warning*/
:host(.gxg-validation--warning) .form-element {
  border-color: var(--color-warning-dark);
}
:host(.gxg-validation--warning) .form-element:focus {
  outline-color: var(--color-warning-dark);
  border-color: var(--color-warning-dark);
}
:host(.gxg-validation--warning) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-warning-dark);
}

/*Error*/
:host(.gxg-validation--error) .form-element {
  border-color: var(--color-error-dark);
}
:host(.gxg-validation--error) .form-element:focus {
  outline-color: var(--color-error-dark);
  border-color: var(--color-error-dark);
}
:host(.gxg-validation--error) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-error-dark);
}

/*Success*/
:host(.gxg-validation--success) .form-element {
  border-color: var(--color-success-dark);
}
:host(.gxg-validation--success) .form-element:focus {
  outline-color: var(--color-success-dark);
  border-color: var(--color-success-dark);
}
:host(.gxg-validation--success) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-success-dark);
}

/*Tooltip*/
.tooltip-outer-wrapper {
  display: grid;
  grid-template-columns: 0fr;
  transition: grid-template-columns var(--timing-02);
}

:host(.tooltip--visible) .tooltip-outer-wrapper {
  grid-template-columns: 1fr;
}

.tooltip-inner-wrapper {
  overflow: hidden;
  transition: 150ms width;
  width: 0;
}
.tooltip-inner-wrapper gxg-icon {
  display: flex;
  position: relative !important;
  top: 0 !important;
  transform: none !important;
  margin-inline-start: var(--spacing-comp-01);
}
.tooltip-inner-wrapper--visible {
  width: 24px;
}
.tooltip-inner-wrapper--hidden {
  display: none;
}

ch-suggest {
  font-family: var(--font-family-primary);
  font-size: var(--font-size-lg);
  color: var(--color-on-background);
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
  /* Track */
  /* Handle */
  /* Handle on hover */
  /* Label */
  /*Input*/
  /*header*/
  /*window*/
}
ch-suggest::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
ch-suggest::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
ch-suggest::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
ch-suggest::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}
ch-suggest ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
ch-suggest ::-webkit-scrollbar-track {
  background-color: var(--gray-02);
  border-radius: 10px;
}
ch-suggest ::-webkit-scrollbar-thumb {
  background: var(--gray-05);
  border-radius: 10px;
}
ch-suggest ::-webkit-scrollbar-thumb:hover {
  background: var(--gray-04);
  cursor: pointer;
}
ch-suggest::part(label) {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  display: flex;
  align-items: center;
  cursor: default;
  font-size: inherit;
}
ch-suggest[label-position=start]::part(label) {
  margin-inline-end: var(--gxg-label-margin-horizontal);
}
ch-suggest[label-position=above]::part(label) {
  margin-block-end: var(--gxg-label-margin-vertical);
}
ch-suggest::part(input) {
  height: var(--spacing-comp-05);
  border: var(--border-width-sm) solid var(--gxg-border-color--regular);
  padding: var(--spacing-comp-01) var(--spacing-comp-02);
  box-sizing: border-box;
  background-color: var(--color-background);
  width: 100%;
}
ch-suggest::part(input):focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
ch-suggest::part(input):focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
ch-suggest::part(header) {
  display: block;
  padding-block-end: var(--spacing-comp-02);
  display: flex;
  justify-content: flex-end;
}
ch-suggest::part(close-button) {
  height: var(--spacing-comp-05);
  width: var(--spacing-comp-05);
  background-color: var(--color-background);
  color: var(--color-primary-hover);
  border: 1px solid var(--color-primary-hover);
  box-sizing: border-box;
  cursor: pointer;
  display: block;
}
ch-suggest::part(close-button):hover {
  background-color: var(--color-primary-hover-opacity-01);
}
ch-suggest::part(close-button)::after {
  content: "✖";
  width: 100%;
  display: block;
  line-height: 24px;
  text-align: center;
}
ch-suggest::part(close-button):focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
ch-suggest::part(dropdown) {
  /*mixin shadow*/
  background-color: var(--color-background);
  margin-top: var(--spacing-comp-01);
  padding: var(--spacing-comp-02);
  box-shadow: var(--box-shadow-02);
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
ch-suggest::part(dropdown)::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
ch-suggest::part(dropdown)::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
ch-suggest::part(dropdown)::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
ch-suggest::part(dropdown)::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}
ch-suggest::part(dropdown) ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
ch-suggest::part(dropdown) ::-webkit-scrollbar-track {
  background-color: var(--gray-02);
  border-radius: 10px;
}
ch-suggest::part(dropdown) ::-webkit-scrollbar-thumb {
  background: var(--gray-05);
  border-radius: 10px;
}
ch-suggest::part(dropdown) ::-webkit-scrollbar-thumb:hover {
  background: var(--gray-04);
  cursor: pointer;
}

/*Validation*/
.messages-wrapper {
  margin-top: var(--spacing-comp-02);
  display: flex;
  gap: var(--spacing-comp-01);
  flex-direction: column;
}

gxg-suggest.gxg-validation--success ch-suggest::part(input) {
  outline-color: var(--color-success-dark);
  border-color: var(--color-success-dark);
}
gxg-suggest.gxg-validation--success ch-suggest::part(input) + .checkmark {
  --checkmark-border-color: var(--color-success-dark);
}

gxg-suggest.gxg-validation--warning ch-suggest::part(input) {
  outline-color: var(--color-warning-dark);
  border-color: var(--color-warning-dark);
}
gxg-suggest.gxg-validation--warning ch-suggest::part(input) + .checkmark {
  --checkmark-border-color: var(--color-warning-dark);
}

gxg-suggest.gxg-validation--error ch-suggest::part(input) {
  outline-color: var(--color-error-dark);
  border-color: var(--color-error-dark);
}
gxg-suggest.gxg-validation--error ch-suggest::part(input) + .checkmark {
  --checkmark-border-color: var(--color-error-dark);
}

/*Disabled*/
gxg-suggest.gxg--disabled ch-suggest {
  pointer-events: none;
}
gxg-suggest.gxg--disabled ch-suggest::part(input) {
  background-color: var(--gray-01);
  color: var(--color-on-disabled);
}

gxg-suggest[ellipsis]:not([ellipsis=false]) ch-suggest-list-item::part(content-wrapper) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

ch-suggest-list {
  margin-block-start: var(--spacing-comp-02);
  font-family: inherit;
  border: var(--border-width-sm) solid var(--gxg-border-color--regular);
}
ch-suggest-list:first-child {
  margin-block-start: 0;
}
ch-suggest-list:last-child {
  margin-block-end: 0;
}
ch-suggest-list::part(title) {
  text-transform: uppercase;
  font-weight: var(--font-weight-semibold);
  margin: var(--spacing-comp-01) 0 0 0;
  padding: var(--spacing-comp-01) var(--spacing-comp-02);
}
ch-suggest-list:first-child {
  margin-block-start: 0;
}

ch-suggest-list + ch-suggest-list {
  margin-block-start: 0;
  border-block-start: 0;
}
ch-suggest-list + ch-suggest-list::part(title) {
  margin-block-start: 0;
}

ch-suggest-list-item {
  /*button*/
}
ch-suggest-list-item::part(button) {
  padding: var(--spacing-comp-01) var(--spacing-comp-02);
  align-items: center;
  gap: var(--spacing-comp-01);
  box-sizing: border-box;
}
ch-suggest-list-item::part(button):focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
ch-suggest-list-item::part(description)::before {
  content: " - ";
}
ch-suggest-list-item gxg-icon::part(ch-icon) {
  --icon-size: 16px;
  margin-right: 2px;
}
ch-suggest-list-item:hover {
  background-color: var(--gxg-background-color--hover);
}